import { useState } from "react";
import { NormasTeachingBundleCheckoutForm } from "./NormasTeachingBundleCheckoutForm.tsx";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { MainContainer } from "../../UI/Layout/MainContainer.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { ErrorPopup } from "../../UI/Error/ErrorPopup.tsx";
import { usePopupController } from "../../HeyLight/usePopupController.ts";
import { useAnalyticsParams } from "../../MoneyTransfer/useAnalyticsParams.ts";
import { useNormasTeachingBundleById } from "../../ProductService/NormasTeachingBundle/useNormasTeachingBundleById.ts";
import { PaymentMethodRouter } from "../PaymentSteps/PaymentMethodRouter.tsx";
import { ItemType, NormasTeachingCheckoutFormData } from "../CheckoutData.ts";
import { NormasTeachingCheckoutItem } from "../PaymentSteps/PaymentMethodStepInterface.ts";

export function NormasTeachingBundleCheckoutScreenInner({
  bundleId,
}: {
  bundleId: string;
}) {
  const { bundle, isLoading } = useNormasTeachingBundleById(bundleId);

  const { openPopup, closePopup, open, title, description } =
    usePopupController();
  const { analyticsParams } = useAnalyticsParams();

  const [checkoutData, setCheckoutData] =
    useState<NormasTeachingCheckoutFormData | null>(null);

  const onFormSubmit = (data: NormasTeachingCheckoutFormData) => {
    setCheckoutData(data);
    setTimeout(() => window.scrollTo(0, 0), 0);
  };

  const onPaymentSuccess = () => {
    setTimeout(() => {
      const succeededUrl = bundle?.stripeConfig?.succeededUrl;
      if (succeededUrl) {
        window.location.href = succeededUrl;
      } else {
        setCheckoutData(null);
      }
    }, 0);
  };

  const onPaymentError = (errorMessage: string) => {
    openPopup({
      title: "Errore nel pagamento",
      description: errorMessage,
      timeoutMs: 5000,
    });
  };

  const onBackToForm = () => {
    setCheckoutData(null);
  };

  if (isLoading) return <FullPageLoading />;
  // A disabled bundle is off sale, so the checkout treats it exactly like one
  // that does not exist. `isEnabled` is absent on bundles created before the
  // flag existed, hence the explicit comparison.
  if (!bundle || bundle.isEnabled === false) return <p>Bundle not found</p>;

  const item: NormasTeachingCheckoutItem = {
    _id: bundle._id,
    priceInCents: bundle.priceInCents,
    itemName: bundle.bundleName,
  };

  return (
    <Layout>
      <NavBar />
      <MainContainer key={checkoutData ? "payment" : "form"}>
        <ErrorPopup
          open={open}
          onClose={closePopup}
          title={title}
          description={description}
        />

        {/* Step 1: Form dati utente + selezione metodo */}
        {!checkoutData && (
          <NormasTeachingBundleCheckoutForm
            submitting={false}
            onFormSubmit={onFormSubmit}
            bundle={bundle}
          />
        )}

        {/* Step 2: Payment Router */}
        {checkoutData && (
          <PaymentMethodRouter
            checkoutData={checkoutData}
            normasTeachingItem={item}
            itemType={ItemType.Bundle}
            analyticsParams={analyticsParams}
            onSuccess={onPaymentSuccess}
            onError={onPaymentError}
            onBack={onBackToForm}
          />
        )}
      </MainContainer>
      <Footer />
    </Layout>
  );
}
